export default __webpack_public_path__ + "static/media/Rami.7d17c9c8.png";